import PropTypes from "prop-types"
import { StrictMode } from "react"
import { Provider } from "react-redux"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { LicenseInfo } from "@mui/x-license"
import DevTools from "./devTools"
import IntercomLauncher from "components/intercom-launcher"
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material"
import materialTheme from "./styles/material"
import { RouterProvider } from "react-router-dom"
import useScrollbarWidth from "hooks/use-scrollbar-width"

import "./styles/index.scss"
import "./styles/legacy.scss"

LicenseInfo.setLicenseKey("db8243089d9e5042f83bbf4cfeeae33bTz0xMTQxNjQsRT0xNzgwNzAzOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y")

const theme = createTheme(materialTheme)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

export default function Root({ store, router }) {
  // Calculate and set scrollbar width as CSS custom property
  useScrollbarWidth()

  return <Provider store={store}>
    <>
      <DevTools />
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <QueryClientProvider client={queryClient}>
            <StrictMode>
              <CssBaseline />
              <RouterProvider router={router} />
            </StrictMode>
          </QueryClientProvider>
        </LocalizationProvider>
      </ThemeProvider>
      <IntercomLauncher />
    </>
  </Provider>
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
}
